import {Component, HostBinding, Input, OnInit} from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-pb-promotion-single',
    templateUrl: './pb-promotion-single.component.html',
    styleUrls: ['./pb-promotion-single.component.scss']
})
export class PbPromotionSingleComponent implements OnInit {

    @Input() content: any = {};
    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    items: any = [];
    @Input() slug: any = '';


    institution: any = {};
    institutionLoaded = false;

    constructor(
        private api: ApiService
    ) {

    }

    ngOnInit(): void {

        this.slug = window.location.pathname.split('/').filter(Boolean).pop();
        console.log(this.slug);

        this.content.forEach(element => {
            var item = {
                content: element.data,
                alignment: this.determineAlignment(element.alignment),
                padding: this.determinePadding(element.padding),
                type: element.item.type
            }

            if (item.type == 'LINK') {
                try {
                    item.content = JSON.parse(item.content);
                } catch (err) { }
            }

            this.items.push(item);
        });

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchInstitution();

    }

    @HostBinding('attr.style')
    public get cssVars() {
        return `
            --bg_color: ${this.institution?.bg_color ? this.institution?.bg_color : '#13426d' };
            --bg_color_2: ${this.institution?.bg_color_2 ? this.institution?.bg_color_2 : '#337ec2' };
        `;
    }

    /**
     * Fetch the institution before fetching the courses
     */
    async fetchInstitution() {

        // await this.api.fetch_institution(this.slug)
        await this.api.fetch_page_builder_institution(this.slug)
            .subscribe(res => {
                this.institution = res.data.item;
                this.institutionLoaded = true;
            }, (err) => {
                // console.log(err);
            });

    }

    /**
     * Alignment is returned as LEFT, CENTER, RIGHT
     * Determine class based on response
     */
    determineAlignment(alignment) {

        if (alignment === 'LEFT') {
            return 'text-left';
        } else if (alignment === 'CENTER') {
            return 'text-center';
        } else if (alignment === 'RIGHT') {
            return 'text-right';
        }

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

}
